import { Text, Box } from 'braid-design-system';

const Bnpl = () => (
  <Box>
    {/* TODO: to change BNPL finalized design */}
    <Text> BNPL component</Text>
  </Box>
);

export default Bnpl;
